const defaultTimeout = 7000;
export const types = [
    {
        type: "info",
        icon: "info-circle",
        color: "#0A99D5",
        manuallyClose: false,
        timeout: defaultTimeout,
    },
    {
        type: "success",
        icon: "check",
        color: "#61BB46",
        manuallyClose: false,
        timeout: defaultTimeout,
    },
    {
        type: "warning",
        icon: "exclamation-triangle",
        color: "#FCB414",
        manuallyClose: false,
        timeout: defaultTimeout,
    },
    {
        type: "error",
        icon: "exclamation-circle",
        color: "#EE3123",
        manuallyClose: false,
        timeout: defaultTimeout,
    },
];
